import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from "../../actions/index.js";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  ROLE_CUSTOMER,
  ROLE_PROVIDER,
  SERVER_URL,
} from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import {
  Clear,
  Add,
  Remove,
  ArrowLeft,
  ArrowRight,
  ArrowForward,
  ArrowBack,
  Category,
  AccessTime,
  CancelOutlined,
} from "@material-ui/icons";
import ContentLoader from "react-content-loader";
import { getCookies } from "../../utils/getToken.js";
import Axios from "axios";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import AreYouSureAlert from "../../components/Alert/AreYouSureAlert.jsx";
import { NotificationManager } from "react-notifications";
import { roundUpTransaction } from "../../utils/roundUpTransaction.js";

class BookingDetailsNewLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAlert: false,
      reschedule_pro_accept_alert: false,
      reschedule_pro_reject_alert: false,
      make_payment_alert: false,
      no_pro_no_show_alert: false,
      confirmed_or_requested_alert: false,

      bookingDetailsDataPrev:
        this.props.history.location.state.bookingDetailsData,
      addressData: [],
      cardListNew: [],
      // bookingListHeadingPrev: this.props.history.location.state.heading,
      read_instruction: false,
    };
  }
  componentDidMount() {
    console.log("bookingDetailsDataPrev", this.state.bookingDetailsDataPrev);
    this.getAddressData();
    this.getCardList();
  }

  componentWillUnmount() {}

  renderLoading = (index) => {
    return (
      <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
        <ContentLoader
          height={200}
          width={200}
          speed={2}
          borderRadius={5}
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
        >
          <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
          <rect x="100" y="100" rx="0" ry="0" width="200" height="10" />
        </ContentLoader>
      </div>
    );
  };

  getAddressData() {
    this.props.getAddressListAction(this.onGetAddressDone);
  }

  getCardList() {
    this.props.cardListAction(this.onCardlistDone);
  }

  onGetAddressDone = (success, data) => {
    if (success) {
      this.setState({
        addressData: data.detail.addresses[0],
        refer_code: data.detail.referral_code,
      });
    }
    // console.log("ADDRESSS NEWWWWWW", this.state.addressData);
  };

  onCardlistDone = (success, data) => {
    if (success) {
      this.setState({ cardListNew: data.sources.data[0] });
    }
    // console.log("CARDDDDDDSSS NEWWWWWW", this.state.cardListNew);
  };

  roundUpTransaction = (transaction) => {
    let roundUpValue = transaction.toString();

    if (roundUpValue.includes(".")) {
      return Number(transaction).toFixed(2);
    } else {
      return Number(transaction);
    }
  };

  onRescheduleByProAccept = async () => {
    var authToken = getCookies();
    console.log("AUTH TOKEN", authToken);
    this.setState({
      showAlert: false,
    });
    try {
      const { data } = await Axios({
        method: "post",
        url: `${SERVER_URL}/booking/user-approve`,
        data: {
          booking_id: this.state.bookingDetailsDataPrev.id,
          status: this.state.bookingDetailsDataPrev.status,
        },
        headers: {
          "x-auth-Token": authToken,
        },
      });
      console.log("Accept reschedule by pro DATA", data);
      if (data.status == "OK") {
        this.setState({
          loading: false,
        });
        NotificationManager.success(data.message, "Success");
        this.props.history.push("/user/manage_bookings");
      } else {
        this.setState({
          loading: false,
        });
        NotificationManager.error(data.message, "Error");
        this.props.history.push("/user/manage_bookings");
      }
    } catch (error) {
      console.log(
        "=========================== RESCHEDULE BY PRO ACCEPT ERRORRRRRR",
        error
      );
    }
  };

  onRescheduleByProReject = async () => {
    var authToken = getCookies();
    console.log("AUTH TOKEN", authToken);
    this.setState({
      showAlert: false,
    });
    try {
      const { data } = await Axios({
        method: "post",
        url: `${SERVER_URL}/booking/user-reject`,
        data: {
          booking_id: this.state.bookingDetailsDataPrev.id,
          status: this.state.bookingDetailsDataPrev.status,
        },
        headers: {
          "x-auth-Token": authToken,
        },
      });
      console.log("Accept reschedule by pro DATA", data);
      if (data.status == "OK") {
        this.setState({
          loading: false,
        });
        NotificationManager.success(data.message, "Success");
        this.props.history.push("/user/manage_bookings");
      } else {
        this.setState({
          loading: false,
        });
        NotificationManager.error(data.message, "Error");
        this.props.history.push("/user/manage_bookings");
      }
    } catch (error) {
      console.log(
        "=========================== RESCHEDULE BY PRO ACCEPT ERRORRRRRR",
        error
      );
    }
  };

  onMakePayment = async () => {
    var authToken = getCookies();
    console.log("AUTH TOKEN", authToken);
    this.setState({
      showAlert: false,
    });
    try {
      const { data } = await Axios({
        method: "post",
        url: `${SERVER_URL}/booking/pay-booking`,
        data: {
          booking_id: this.state.bookingDetailsDataPrev.id,
          city: this.state.bookingDetailsDataPrev.address_city,
          booking_value: this.state.bookingDetailsDataPrev.booking_value,
          task_id: this.state.bookingDetailsDataPrev.booking_task_id,
        },
        headers: {
          "x-auth-Token": authToken,
        },
      });
      console.log("make payment data", data);
      if (data.status == "OK") {
        this.setState({
          loading: false,
        });
        NotificationManager.success(data.message, "Success");
        this.props.history.push("/user/manage_bookings");
      } else {
        this.setState({
          loading: false,
        });
        NotificationManager.error(data.message, "Error");
        this.props.history.push("/user/manage_bookings");
      }
    } catch (error) {
      console.log(
        "=========================== in cart make payment ERRORRRRRR",
        error
      );
    }
  };

  onCanelBooking = async () => {
    var authToken = getCookies();
    console.log("AUTH TOKEN", authToken);
    this.setState({
      showAlert: false,
    });
    try {
      const { data } = await Axios({
        method: "post",
        url: `${SERVER_URL}/booking/update-substatus`,
        data: {
          booking_id: this.state.bookingDetailsDataPrev.id,
          sub_status: "cancelled",
        },
        headers: {
          "x-auth-Token": authToken,
        },
      });
      console.log("cancel booking data", data);
      if (data.status == "OK") {
        this.setState({
          loading: false,
        });
        NotificationManager.success(data.message, "Success");
        this.props.history.push("/user/manage_bookings");
      } else {
        this.setState({
          loading: false,
        });
        NotificationManager.error(data.message, "Error");
        this.props.history.push("/user/manage_bookings");
      }
    } catch (error) {
      console.log(
        "=========================== cancel booking ERRORRRRRR",
        error
      );
    }
  };

  onCanelNormalBooking = async () => {
    var authToken = getCookies();
    console.log("AUTH TOKEN", authToken);
    this.setState({
      showAlert: false,
    });
    try {
      const { data } = await Axios({
        method: "post",
        url: `${SERVER_URL}/booking/delete`,
        data: {
          booking_id: this.state.bookingDetailsDataPrev.id,
          status: this.state.bookingDetailsDataPrev.status,
        },
        headers: {
          "x-auth-Token": authToken,
        },
      });
      console.log("cancel booking data", data);
      if (data.status == "OK") {
        this.setState({
          loading: false,
        });
        NotificationManager.success(data.message, "Success");
        this.props.history.push("/user/manage_bookings");
      } else {
        this.setState({
          loading: false,
        });
        NotificationManager.error(data.message, "Error");
        this.props.history.push("/user/manage_bookings");
      }
    } catch (error) {
      console.log(
        "=========================== cancel booking ERRORRRRRR",
        error
      );
    }
  };

  render() {
    let d =
      Date.now() - Date.parse(this.state.bookingDetailsDataPrev.updated_at);
    let a = d / (60 * 60 * 1000);
    let gap_time = 24 - Math.floor(a);
    console.log("aaaassssssssssssssss", this.state.bookingDetailsDataPrev);

    var well = {
      boxShadow: "2px 1px 5px #ddd",
      backgroundColor: "#fff",
      padding: 10,
      marginBottom: 20,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      // textAlign: 'center',
      cursor: "pointer",
      borderRadius: 5,
    };
    var card = {
      border: "1px solid #eee",
      boxShadow: "1px 1px 20px #ddd",
      borderRadius: "10px",
      marginBottom: 10,
      padding: 15,
      height: "380px",
      // flexDirection: "column",
    };
    var cardHeading = {
      backgroundColor: "#0078ff",
      color: "white",
      fontWeight: "600",
      padding: "5px 20px",
      borderRadius: 50,
      fontSize: 18,
      marginBottom: 25,
      marginBottom: 20,
    };
    var infoHead = {
      color: "green",
      fontSize: 18,
      fontWeight: "700",
      marginBottom: 0,
    };

    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let originalDate = this.state.bookingDetailsDataPrev.booking_date;
    let year = originalDate.substring(0, 4);
    let month = Number(originalDate.substring(5, 7)) - 1;
    let date = originalDate.substring(8, 10);
    let formattedDate = monthNames[month] + " " + date + ", " + year;

    return (
      <div className="tz-2-com tz-2-main h4-padding">
        <div style={{ paddingBottom: "25px" }} className="db-list-com">
          <div className="row">
            <div className="col-md-12">
              <NavbarNew
                title="Booking Details"
                goback={() => this.props.history.goBack(null)}
              />

              {/* new design */}
              <div
                id="booking_details"
                style={{
                  width: "100%",
                  display: "flex",
                }}
              >
                <div
                  id="booking_details1"
                  style={{
                    width: "50%",
                    // backgroundColor: 'lightgreen',
                    display: "flex",
                    flexDirection: "column",
                    padding: 10,
                  }}
                >
                  <div id="booking_details1" style={card}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p id="font" style={cardHeading}>
                        Booking Info
                      </p>
                      {this.state.bookingDetailsDataPrev.status ===
                        "no-provider" && (
                        <div style={{}}>
                          <p
                            style={{
                              color: "red",
                              fontSize: 15,
                              fontWeight: "bold",
                            }}
                          >
                            No Provider Available
                          </p>
                        </div>
                      )}
                      {this.state.bookingDetailsDataPrev.status ===
                        "rescheduled-provider" && (
                        <div style={{}}>
                          <p
                            style={{
                              color: "red",
                              fontSize: 15,
                              fontWeight: "bold",
                            }}
                          >
                            Rescheduled by Provider
                          </p>
                        </div>
                      )}
                      {this.state.bookingDetailsDataPrev.status ===
                        "completed" && (
                        <div style={{}}>
                          <p
                            style={{
                              color: "red",
                              fontSize: 15,
                              fontWeight: "bold",
                            }}
                          >
                            Auto closed in {gap_time} hrs
                          </p>
                        </div>
                      )}
                      {this.state.bookingDetailsDataPrev.status ===
                        "no-show" && (
                        <div style={{}}>
                          <p
                            style={{
                              color: "red",
                              fontSize: 15,
                              fontWeight: "bold",
                            }}
                          >
                            Provider No Show
                          </p>
                        </div>
                      )}
                      {this.state.bookingDetailsDataPrev.status ===
                        "closed" && (
                        <div style={{}}>
                          <p
                            id="font"
                            style={{
                              color: "green",
                              fontSize: 15,
                              fontWeight: "bold",
                            }}
                          >
                            Booking Completed
                          </p>
                        </div>
                      )}
                      {this.state.bookingDetailsDataPrev.status ===
                        "denied" && (
                        <div style={{}}>
                          <p
                            style={{
                              color: "orange",
                              fontSize: 15,
                              fontWeight: "bold",
                            }}
                          >
                            Pending Approval
                          </p>
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p style={infoHead}>{formattedDate}</p>
                      {(this.state.bookingDetailsDataPrev.status ===
                        "confirmed" ||
                        this.state.bookingDetailsDataPrev.status ===
                          "no-show") && (
                        <p
                          style={{
                            textDecoration: "underline",
                            color: "#0078ff",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            this.props.history.push("/user/provider_info", {
                              bookingDetails: this.state.bookingDetailsDataPrev,
                            })
                          }
                        >
                          Provider Info
                        </p>
                      )}
                    </div>

                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                        marginBottom: 20,
                      }}
                    >
                      {this.state.bookingDetailsDataPrev.booking_slot}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                      }}
                    >
                      Booking#{" "}
                      <span style={{ color: "#0078ff", fontWeight: "bold" }}>
                        {this.state.bookingDetailsDataPrev.booking_number}
                      </span>
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                        fontWeight: "bold",
                      }}
                    >
                      {
                        this.state.bookingDetailsDataPrev.taskData.full_name
                          .service
                      }{" "}
                      (
                      {
                        this.state.bookingDetailsDataPrev.taskData.full_name
                          .master_category
                      }{" "}
                      /{" "}
                      {
                        this.state.bookingDetailsDataPrev.taskData.full_name
                          .category
                      }
                      )
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                        marginBottom: 20,
                      }}
                    >
                      Description:{" "}
                      {this.state.bookingDetailsDataPrev.taskData.description}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                      }}
                    >
                      Booking Type:{" "}
                      {this.state.bookingDetailsDataPrev.taskData.service_type}{" "}
                      |{" "}
                      {this.state.bookingDetailsDataPrev.taskData.booking_type}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                      }}
                    >
                      Booking Unit:{" "}
                      {this.state.bookingDetailsDataPrev.booking_quantity}
                    </p>
                    <div
                      id="font"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        id="font"
                        style={{
                          fontSize: 18,
                          marginBottom: 0,
                          fontWeight: "bold",
                        }}
                      >
                        Total Charges: $
                        {roundUpTransaction(
                          this.state.bookingDetailsDataPrev.booking_value
                        )}
                      </p>
                    </div>
                  </div>

                  {/* <div id="additional_font" style={card}>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p id="font" style={cardHeading}>
                          Additional Infooooooooooooooooo
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <p
                          id="font"
                          style={{
                            fontSize: 18,
                          }}
                        >
                          <span id="font" style={{ fontWeight: "bold" }}>
                            Will be Home
                          </span>{" "}
                          -{" "}
                          {this.state.bookingDetailsDataPrev.home_stay == 2
                            ? "No"
                            : "Yes"}
                        </p>
                        {this.state.bookingDetailsDataPrev.home_stay == 2 ? (
                          <p
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: "#0078ff",
                            }}
                            onClick={() =>
                              this.setState({
                                read_instruction: !this.state.read_instruction,
                              })
                            }
                          >
                            {this.state.read_instruction
                              ? "Hide Instruction"
                              : "Read Instruction"}
                          </p>
                        ) : null}
                      </div>
                      {this.state.read_instruction ? (
                        <p
                          style={{
                            fontSize: 18,
                          }}
                        >
                          {this.state.bookingDetailsDataPrev.home_instruction}
                        </p>
                      ) : null}
                    </div>
                    <div
                      style={{
                        marginTop: 20,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 18,
                        }}
                      >
                        <span id="font" style={{ fontWeight: "bold" }}>
                          Notes / Instructions
                        </span>
                      </p>
                      <p
                        style={{
                          fontSize: 18,
                        }}
                      >
                        {this.state.bookingDetailsDataPrev.instructions}
                      </p>
                    </div>
                    <div
                      style={{
                        marginTop: 25,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 18,
                        }}
                      >
                        <span id="font" style={{ fontWeight: "bold" }}>
                          Uploaded Photos
                        </span>
                      </p>
                      <div
                        id="add_photo"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                          borderRadius: "10px",
                          overflow: "auto",
                          overflowY: "hidden",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                            padding: "5px",
                            border: "1px solid #eee",
                            borderRadius: "10px",
                            padding: "2px 0px 2px 0px",
                          }}
                        >
                          {this.state.bookingDetailsDataPrev.booking_img1 ? (
                            <img
                              src={
                                this.state.bookingDetailsDataPrev.booking_img1
                              }
                              style={{
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                backgroundColor: "#ddd",
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                No Photo Added
                              </p>
                            </div>
                          )}
                          {this.state.bookingDetailsDataPrev.booking_img2 ? (
                            <img
                              src={
                                this.state.bookingDetailsDataPrev.booking_img2
                              }
                              style={{
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                backgroundColor: "#ddd",
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                No Photo Added
                              </p>
                            </div>
                          )}
                          {this.state.bookingDetailsDataPrev.booking_img3 ? (
                            <img
                              src={
                                this.state.bookingDetailsDataPrev.booking_img3
                              }
                              style={{
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                backgroundColor: "#ddd",
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                No Photo Added
                              </p>
                            </div>
                          )}
                          {this.state.bookingDetailsDataPrev.booking_img4 ? (
                            <img
                              src={
                                this.state.bookingDetailsDataPrev.booking_img4
                              }
                              style={{
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                backgroundColor: "#ddd",
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                No Photo Added
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div style={card}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p id="font" style={cardHeading}>
                        Payment Method
                      </p>
                    </div>
                    <p style={infoHead}>
                      Card - {this.state.cardListNew.brand}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                      }}
                    >
                      Card Number - **** **** ****{" "}
                      {this.state.cardListNew.last4}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                      }}
                    >
                      Expiry - {this.state.cardListNew.exp_month}/
                      {this.state.cardListNew.exp_year}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                      }}
                    >
                      Amount Paid - $
                      {roundUpTransaction(
                        this.state.bookingDetailsDataPrev.pay_amount
                      )}
                    </p>
                  </div>

                  {/* <div style={card}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p id="font" style={cardHeading}>
                        Payment Method
                      </p>
                    </div>
                    <p style={infoHead}>
                      Card - {this.state.cardListNew.brand}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                      }}
                    >
                      Card Number - **** **** ****{" "}
                      {this.state.cardListNew.last4}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                      }}
                    >
                      Expiry - {this.state.cardListNew.exp_month}/
                      {this.state.cardListNew.exp_year}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                      }}
                    >
                      Amount Paid - $
                      {roundUpTransaction(
                        this.state.bookingDetailsDataPrev.pay_amount
                      )}
                    </p>
                  </div> */}

                  <div
                    id="booking_details1"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      // padding: 10,
                    }}
                  >
                    {this.state.bookingDetailsDataPrev.status === "completed" ||
                    this.state.bookingDetailsDataPrev.status === "closed" ||
                    this.state.bookingDetailsDataPrev.status === "denied" ||
                    this.state.bookingDetailsDataPrev.status ===
                      "denied-confirmed" ? (
                      <div id="additional_font" style={card}>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <p id="font" style={cardHeading}>
                              Completed Info
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            marginTop: 20,
                          }}
                        >
                          <p
                            style={{
                              fontSize: 18,
                            }}
                          >
                            <span id="font" style={{ fontWeight: "bold" }}>
                              Notes / Instructions
                            </span>
                          </p>
                          <p
                            style={{
                              fontSize: 18,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              // whiteSpace: "nowrap",
                            }}
                          >
                            {this.state.bookingDetailsDataPrev.completion_note}
                          </p>
                        </div>
                        <div
                          style={{
                            marginTop: 25,
                          }}
                        >
                          <p
                            style={{
                              fontSize: 18,
                            }}
                          >
                            <span id="font" style={{ fontWeight: "bold" }}>
                              Uploaded Photos
                            </span>
                          </p>
                          <div
                            id="add_photo"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-around",
                              alignItems: "center",
                              borderRadius: "10px",
                              // overflow: "auto",
                              // overflowY: "hidden",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                                // padding: "5px",
                                // border: "1px solid #eee",
                                borderRadius: "10px",
                                width: "100%",
                                // padding: "2px 0px 2px 0px",
                              }}
                            >
                              {this.state.bookingDetailsDataPrev
                                .completion_img1 ? (
                                <img
                                  src={
                                    this.state.bookingDetailsDataPrev
                                      .completion_img1
                                  }
                                  style={{
                                    height: "7rem",
                                    width: "7rem",
                                    borderRadius: 10,
                                    margin: 5,
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "7rem",
                                    width: "7rem",
                                    borderRadius: 10,
                                    backgroundColor: "#ddd",
                                    margin: 5,
                                  }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                    }}
                                  >
                                    No Photo Added
                                  </p>
                                </div>
                              )}
                              {this.state.bookingDetailsDataPrev
                                .completion_img2 ? (
                                <img
                                  src={
                                    this.state.bookingDetailsDataPrev
                                      .completion_img2
                                  }
                                  style={{
                                    height: "7rem",
                                    width: "7rem",
                                    borderRadius: 10,
                                    margin: 5,
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "7rem",
                                    width: "7rem",
                                    borderRadius: 10,
                                    backgroundColor: "#ddd",
                                    margin: 5,
                                  }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                    }}
                                  >
                                    No Photo Added
                                  </p>
                                </div>
                              )}
                              {this.state.bookingDetailsDataPrev
                                .completion_img3 ? (
                                <img
                                  src={
                                    this.state.bookingDetailsDataPrev
                                      .completion_img3
                                  }
                                  style={{
                                    height: "7rem",
                                    width: "7rem",
                                    borderRadius: 10,
                                    margin: 5,
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "7rem",
                                    width: "7rem",
                                    borderRadius: 10,
                                    backgroundColor: "#ddd",
                                    margin: 5,
                                  }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                    }}
                                  >
                                    No Photo Added
                                  </p>
                                </div>
                              )}
                              {this.state.bookingDetailsDataPrev
                                .completion_img4 ? (
                                <img
                                  src={
                                    this.state.bookingDetailsDataPrev
                                      .completion_img4
                                  }
                                  style={{
                                    height: "7rem",
                                    width: "7rem",
                                    borderRadius: 10,
                                    margin: 5,
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "7rem",
                                    width: "7rem",
                                    borderRadius: 10,
                                    backgroundColor: "#ddd",
                                    margin: 5,
                                  }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                    }}
                                  >
                                    No Photo Added
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div
                  id="booking_details1"
                  style={{
                    width: "50%",
                    // backgroundColor: 'lightgreen',
                    display: "flex",
                    flexDirection: "column",
                    padding: 10,
                  }}
                >
                  <div style={{ ...card }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p id="font" style={cardHeading}>
                        Booking Address
                      </p>
                    </div>
                    <p id="font" style={infoHead}>
                      {this.state.addressData.city}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                      }}
                    >
                      {this.state.addressData.address_line1}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                      }}
                    >
                      State - {this.state.addressData.state}
                    </p>
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                      }}
                    >
                      Zip - {this.state.addressData.zipcode}
                    </p>
                  </div>

                  <div id="additional_font" style={card}>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p id="font" style={cardHeading}>
                          Additional Info
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <p
                          id="font"
                          style={{
                            fontSize: 18,
                          }}
                        >
                          <span id="font" style={{ fontWeight: "bold" }}>
                            Will be Home
                          </span>{" "}
                          -{" "}
                          {this.state.bookingDetailsDataPrev.home_stay == 2
                            ? "No"
                            : "Yes"}
                        </p>
                        {this.state.bookingDetailsDataPrev.home_stay == 2 ? (
                          <p
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: "#0078ff",
                            }}
                            onClick={() =>
                              this.setState({
                                read_instruction: !this.state.read_instruction,
                              })
                            }
                          >
                            {this.state.read_instruction
                              ? "Hide Instruction"
                              : "Read Instruction"}
                          </p>
                        ) : null}
                      </div>
                      {this.state.read_instruction ? (
                        <p
                          style={{
                            fontSize: 18,
                          }}
                        >
                          {this.state.bookingDetailsDataPrev.home_instruction}
                        </p>
                      ) : null}
                    </div>
                    <div
                      style={{
                        marginTop: 20,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 18,
                        }}
                      >
                        <span id="font" style={{ fontWeight: "bold" }}>
                          Notes / Instructions
                        </span>
                      </p>
                      <p
                        style={{
                          fontSize: 18,
                        }}
                      >
                        {this.state.bookingDetailsDataPrev.instructions}
                      </p>
                    </div>
                    <div
                      style={{
                        marginTop: 25,
                      }}
                    >
                      <p
                        style={{
                          fontSize: 18,
                        }}
                      >
                        <span id="font" style={{ fontWeight: "bold" }}>
                          Uploaded Photos
                        </span>
                      </p>
                      <div
                        id="add_photo"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          alignItems: "center",
                          borderRadius: "10px",
                          // overflow: "auto",
                          // overflowY: "hidden",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                            width: "100%",

                        
                          }}
                        >
                          {this.state.bookingDetailsDataPrev.booking_img1 ? (
                            <img
                              src={
                                this.state.bookingDetailsDataPrev.booking_img1
                              }
                              style={{
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                margin:5
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                backgroundColor: "#ddd",
                                margin:5
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                No Photo Added
                              </p>
                            </div>
                          )}
                          {this.state.bookingDetailsDataPrev.booking_img2 ? (
                            <img
                              src={
                                this.state.bookingDetailsDataPrev.booking_img2
                              }
                              style={{
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                margin:5
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                backgroundColor: "#ddd",
                                margin:5
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                No Photo Added
                              </p>
                            </div>
                          )}
                          {this.state.bookingDetailsDataPrev.booking_img3 ? (
                            <img
                              src={
                                this.state.bookingDetailsDataPrev.booking_img3
                              }
                              style={{
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                margin:5
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                backgroundColor: "#ddd",
                                margin:5
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                No Photo Added
                              </p>
                            </div>
                          )}
                          {this.state.bookingDetailsDataPrev.booking_img4 ? (
                            <img
                              src={
                                this.state.bookingDetailsDataPrev.booking_img4
                              }
                              style={{
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                margin:5
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "7rem",
                                width: "7rem",
                                borderRadius: 10,
                                backgroundColor: "#ddd",
                                margin:5
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                No Photo Added
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {this.state.bookingDetailsDataPrev.status === "denied" ||
                  this.state.bookingDetailsDataPrev.status ===
                    "denied-confirmed" ? (
                    <div id="additional_font" style={card}>
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <p id="font" style={cardHeading}>
                            Rejection Info
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                        }}
                      >
                        <p
                          style={{
                            fontSize: 18,
                          }}
                        >
                          <span id="font" style={{ fontWeight: "bold" }}>
                            Notes / Instructions
                          </span>
                        </p>
                        <p
                          style={{
                            fontSize: 18,
                          }}
                        >
                          {this.state.bookingDetailsDataPrev.reject_reason}
                        </p>
                      </div>
                      <div
                        style={{
                          marginTop: 25,
                        }}
                      >
                        <p
                          style={{
                            fontSize: 18,
                          }}
                        >
                          <span id="font" style={{ fontWeight: "bold" }}>
                            Uploaded Photos
                          </span>
                        </p>
                        <div
                          id="add_photo"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-around",
                            alignItems: "center",
                            borderRadius: "10px",
                          
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-evenly",
                              alignItems: "center",
                              width:"100%"
                            
                            }}
                          >
                            {this.state.bookingDetailsDataPrev.reject_img1 ? (
                              <img
                                src={
                                  this.state.bookingDetailsDataPrev.reject_img1
                                }
                                style={{
                                  height: "7rem",
                                  width: "7rem",
                                  borderRadius: 10,
                                  margin:5
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "7rem",
                                  width: "7rem",
                                  borderRadius: 10,
                                  backgroundColor: "#ddd",
                                  margin:5
                                }}
                              >
                                <p
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  No Photo Added
                                </p>
                              </div>
                            )}
                            {this.state.bookingDetailsDataPrev.reject_img2 ? (
                              <img
                                src={
                                  this.state.bookingDetailsDataPrev.reject_img2
                                }
                                style={{
                                  height: "7rem",
                                  width: "7rem",
                                  borderRadius: 10,
                                  margin:5
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "7rem",
                                  width: "7rem",
                                  borderRadius: 10,
                                  backgroundColor: "#ddd",
                                  margin:5
                                }}
                              >
                                <p
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  No Photo Added
                                </p>
                              </div>
                            )}
                            {this.state.bookingDetailsDataPrev.reject_img3 ? (
                              <img
                                src={
                                  this.state.bookingDetailsDataPrev.reject_img3
                                }
                                style={{
                                  height: "7rem",
                                  width: "7rem",
                                  borderRadius: 10,
                                  margin:5
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "7rem",
                                  width: "7rem",
                                  borderRadius: 10,
                                  backgroundColor: "#ddd",
                                  margin:5
                                }}
                              >
                                <p
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  No Photo Added
                                </p>
                              </div>
                            )}
                            {this.state.bookingDetailsDataPrev.reject_img4 ? (
                              <img
                                src={
                                  this.state.bookingDetailsDataPrev.reject_img4
                                }
                                style={{
                                  height: "7rem",
                                  width: "7rem",
                                  borderRadius: 10,
                                  margin:5
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "7rem",
                                  width: "7rem",
                                  borderRadius: 10,
                                  backgroundColor: "#ddd",
                                  margin:5
                                }}
                              >
                                <p
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  No Photo Added
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {this.state.bookingDetailsDataPrev.status === "closed" ? (
                    <div style={{ ...card }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p id="font" style={cardHeading}>
                          Acceptance Info
                        </p>
                      </div>

                      <p
                        id="font"
                        style={{
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Rating -{" "}
                        {
                          this.state.bookingDetailsDataPrev
                            .booking_closure_rating
                        }
                      </p>
                      <p
                        id="font"
                        style={{
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Feedback -{" "}
                        {
                          this.state.bookingDetailsDataPrev
                            .booking_closure_feedback
                        }
                      </p>
                    </div>
                  ) : null}
                </div>
              </div>

              {(this.state.bookingDetailsDataPrev.status === "no-provider" ||
                this.state.bookingDetailsDataPrev.status === "no-show") && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 20,
                    marginRight: 15,
                    marginRight: 15,
                  }}
                >
                  <p
                    onClick={() => {
                      this.setState({ no_pro_no_show_alert: true });
                    }}
                    style={{
                      backgroundColor: "red",
                      padding: 10,
                      color: "#fff",
                      borderRadius: 5,
                      fontSize: 17,
                      textAlign: "center",
                      marginRight: 15,
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 110,
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </p>
                  <p
                    onClick={() =>
                      this.props.history.push("/user/rebook", {
                        bookingData: this.state.bookingDetailsDataPrev,
                      })
                    }
                    style={{
                      backgroundColor: "#0078ff",
                      padding: 10,
                      color: "#fff",
                      borderRadius: 5,
                      fontSize: 17,
                      textAlign: "center",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 110,
                      cursor: "pointer",
                    }}
                  >
                    Rebook
                  </p>
                </div>
              )}
              {this.state.bookingDetailsDataPrev.status === "completed" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 20,
                    marginRight: 15,
                  }}
                >
                  <p
                    onClick={() =>
                      this.props.history.push("/user/booking_rejection", {
                        bookingData: this.state.bookingDetailsDataPrev,
                      })
                    }
                    style={{
                      backgroundColor: "red",
                      padding: 10,
                      color: "#fff",
                      borderRadius: 5,
                      fontSize: 17,
                      textAlign: "center",
                      marginRight: 15,
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 110,
                      cursor: "pointer",
                    }}
                  >
                    Decline
                  </p>
                  <p
                    onClick={() =>
                      this.props.history.push("/user/booking_approval", {
                        bookingData: this.state.bookingDetailsDataPrev,
                      })
                    }
                    style={{
                      backgroundColor: "#0078ff",
                      padding: 10,
                      color: "#fff",
                      borderRadius: 5,
                      fontSize: 17,
                      textAlign: "center",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 110,
                      cursor: "pointer",
                    }}
                  >
                    Accept
                  </p>
                </div>
              )}
              {this.state.bookingDetailsDataPrev.status ===
                "rescheduled-provider" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 20,
                    marginRight: 15,
                  }}
                >
                  <p
                    onClick={() => {
                      this.setState({ reschedule_pro_reject_alert: true });
                    }}
                    style={{
                      backgroundColor: "red",
                      padding: 10,
                      color: "#fff",
                      borderRadius: 5,
                      fontSize: 17,
                      textAlign: "center",
                      marginRight: 15,
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 110,
                      cursor: "pointer",
                    }}
                  >
                    Decline
                  </p>
                  <p
                    onClick={() => {
                      this.setState({ reschedule_pro_accept_alert: true });
                    }}
                    style={{
                      backgroundColor: "#0078ff",
                      padding: 10,
                      color: "#fff",
                      borderRadius: 5,
                      fontSize: 17,
                      textAlign: "center",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 110,
                      cursor: "pointer",
                    }}
                  >
                    Accept
                  </p>
                </div>
              )}
              {(this.state.bookingDetailsDataPrev.status === "confirmed" ||
                this.state.bookingDetailsDataPrev.status === "requested") && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 20,
                    marginRight: 15,
                  }}
                >
                  <p
                    onClick={() => {
                      this.setState({ confirmed_or_requested_alert: true });
                    }}
                    style={{
                      backgroundColor: "red",
                      padding: 10,
                      color: "#fff",
                      borderRadius: 5,
                      fontSize: 17,
                      textAlign: "center",
                      marginRight: 15,
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 110,
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </p>
                  <p
                    onClick={() =>
                      this.props.history.push("/user/reschedule", {
                        bookingData: this.state.bookingDetailsDataPrev,
                      })
                    }
                    style={{
                      backgroundColor: "#0078ff",
                      padding: 10,
                      color: "#fff",
                      borderRadius: 5,
                      fontSize: 17,
                      textAlign: "center",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 110,
                      cursor: "pointer",
                    }}
                  >
                    Reschedule
                  </p>
                </div>
              )}
              {this.state.bookingDetailsDataPrev.status === "in-cart" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 20,
                    marginRight: 15,
                  }}
                >
                  <p
                    onClick={() => {
                      this.setState({ make_payment_alert: true });
                    }}
                    style={{
                      backgroundColor: "#0078ff",
                      padding: 10,
                      color: "#fff",
                      borderRadius: 5,
                      fontSize: 17,
                      textAlign: "center",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    Make Payment
                  </p>
                </div>
              )}
              {(this.state.bookingDetailsDataPrev.status === "closed" ||
                this.state.bookingDetailsDataPrev.status === "rejected") && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 20,
                    marginRight: 15,
                  }}
                >
                  <p
                    onClick={() =>
                      this.props.history.push("/user/rebook", {
                        bookingData: this.state.bookingDetailsDataPrev,
                      })
                    }
                    style={{
                      backgroundColor: "#0078ff",
                      padding: 10,
                      color: "#fff",
                      borderRadius: 5,
                      fontSize: 17,
                      textAlign: "center",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 110,
                      cursor: "pointer",
                    }}
                  >
                    Rebook{" "}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        <AreYouSureAlert
          open={this.state.reschedule_pro_accept_alert}
          title=""
          content="You are approving the Reschedule request. Do you want to continue?"
          close={() => this.setState({ reschedule_pro_accept_alert: false })}
          handleYes={this.onRescheduleByProAccept}
          handleNo={() => this.setState({ reschedule_pro_accept_alert: false })}
        />
        <AreYouSureAlert
          open={this.state.reschedule_pro_reject_alert}
          title=""
          content="This will cancel your current booking appointment. If the appointment time is near or has already started you will need to schedule a new job as this job will be canceled. If the booking time is in the future your job will automatically be seen by another Pro to accept, so no rescheudling needed. If you do not want the job anymore, please Cancel. Do you want to continue?"
          close={() => this.setState({ reschedule_pro_reject_alert: false })}
          handleYes={this.onRescheduleByProReject}
          handleNo={() => this.setState({ reschedule_pro_reject_alert: false })}
        />
        <AreYouSureAlert
          open={this.state.make_payment_alert}
          title=""
          content="Final step! ezPro will charge your payment method now and holds your funds until the Pro finishes the job and you verifiy the job is completed within 24 hours. You can also Reject the Pros work in order to get the Pro to fix any issues that remain related to your job, so the Pro is not paid before the work is completed. You can cancel and be refunded before the job start time. You can also reschedule with the Pro as well. Do you want to continue?"
          close={() => this.setState({ make_payment_alert: false })}
          handleYes={this.onMakePayment}
          handleNo={() => this.setState({ make_payment_alert: false })}
        />
        <AreYouSureAlert
          open={this.state.no_pro_no_show_alert}
          title=""
          content="This will cancel your booking . Do you want to continue?"
          close={() => this.setState({ no_pro_no_show_alert: false })}
          handleYes={this.onCanelBooking}
          handleNo={() => this.setState({ no_pro_no_show_alert: false })}
        />
        <AreYouSureAlert
          open={this.state.confirmed_or_requested_alert}
          title=""
          content="This will cancel your booking . Do you want to continue?"
          close={() => this.setState({ confirmed_or_requested_alert: false })}
          handleYes={this.onCanelNormalBooking}
          handleNo={() =>
            this.setState({ confirmed_or_requested_alert: false })
          }
        />
      </div>
    );
  }
}

const mapStateToProps = ({ settings, categories, providers }) => {
  return {
    settings,
    categoryData: categories.categoryData,
    featuredProviderList: providers.featuredProviderList,
    featuredProviderLoader: providers.featuredProviderLoader,
  };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(BookingDetailsNewLayout));



// WEBPACK FOOTER //
// ./src/views/User/BookingDetailsNewLayout.jsx